"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorContainer = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var styled_components_1 = __importDefault(require("styled-components"));
exports.ErrorContainer = styled_components_1.default.div.attrs({})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", " {\n\t\tpadding: 3px;\n\t\tmargin-bottom: 50px;\n\t}\n"], ["\n\t", " {\n\t\tpadding: 3px;\n\t\tmargin-bottom: 50px;\n\t}\n"])), aon_tws_common_ui_1.errorText);
exports.ErrorContainer.displayName = 'ErrorContainer';
var templateObject_1;
